var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJunitInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.25,14.5v-1a1,1,0,0,1,2,0v1a1,1,0,0,0,2,0v-6a1,1,0,0,1,2,0v5.25l1-1V8.5a1,1,0,0,1,2,0v2.25L20,4,17.59,1.59A2,2,0,0,0,16.17,1H3A2,2,0,0,0,1,3V21a2,2,0,0,0,.59,1.41l5-5A3,3,0,0,1,4.25,14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20,4l-6.75,6.75V13.5a2,2,0,0,0,4,0v-5a1,1,0,0,1,2,0v5a4,4,0,0,1-8,0v-.75l-1,1v.75a3,3,0,0,1-3.67,2.92l-5,5A2,2,0,0,0,3,23H21a2,2,0,0,0,2-2V7.83a2,2,0,0,0-.59-1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunitInactive);
export default __webpack_public_path__ + "static/media/junit-inactive.2b0d9074ed587389a4a884999c434c21.svg";
export { ForwardRef as ReactComponent };